import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useClient } from '@/hooks/useClient'

/** Providers in the org who can be asked to sign (coordinators are excluded server-side). */
export function useLetterSigners(enabled: boolean) {
  const client = useClient()

  const query = useQuery({
    queryKey: ['letter-signers'],
    queryFn: () => client.letterSigners({}),
    enabled,
    staleTime: 5 * 60_000,
  })

  const options = useMemo(
    () => (query.data?.signers ?? []).map((signer) => ({ value: signer.id, label: signer.name })),
    [query.data],
  )

  return { options, loading: query.isLoading }
}
